import { render, staticRenderFns } from "./Replerhof.vue?vue&type=template&id=b16d8c02&"
import script from "./Replerhof.vue?vue&type=script&lang=js&"
export * from "./Replerhof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports